import client from '../utils/client';
import { faqsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const faqService = {
  faqsList,
  addFaq,
  getFaq,
  updateFaq
}

function faqsList() {
  return client.get(faqsUrl)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addFaq(formDate) {
  return client.post(faqsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getFaq(faqID) {
  return client.get(faqsUrl + '/' + faqID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateFaq(formDate) {
  return client.post(faqsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}